// API服务统一入口文件
import apiClient from './config'
import authAPI from './auth'
import productsAPI from './products'

// 导出所有API服务
export {
  apiClient,
  authAPI,
  productsAPI
}

// 默认导出
export default {
  auth: authAPI,
  products: productsAPI,
  client: apiClient
}